import {utils} from '@wallaby-ui/core';
import {format} from 'date-fns';

import DateRangeFilter from './date_range_filter';
import {FilterUtils} from 'src/js/lib/filtering';
import {FILTER_TYPE_DATE_ONLY_RANGE} from 'src/js/lib/filtering/filters_definitions_constants';

class DateOnlyRangeFilter extends DateRangeFilter {
  constructor(filterData) {
    super(filterData);
    this.type = filterData.type || FILTER_TYPE_DATE_ONLY_RANGE;
  }

  static fromString(serializedFilter) {
    if (serializedFilter.endsWith(':*')) {
      return new DateOnlyRangeFilter({
        property: serializedFilter.slice(0, -2),
        value: null,
      });
    }
    const {rangeFrom, rangeTo, property} =
      FilterUtils.getRangeFromString(serializedFilter);
    return new DateOnlyRangeFilter({
      property,
      value: {startDate: rangeFrom, endDate: rangeTo},
    });
  }

  static fromSchema(schemaNode) {
    return new DateOnlyRangeFilter({property: schemaNode.getName()});
  }

  clone() {
    return new DateOnlyRangeFilter({
      type: this.type,
      property: this.property,
      value: {...this.value},
      shortcut: this.shortcut,
      id: this.id,
    });
  }

  toString() {
    if (this.value != null) {
      const startDateFormatted = format(
        new Date(this.value.startDate),
        utils.DateUtils.ISO_DATE_ONLY_FORMAT
      );
      const endDateFormatted = format(
        new Date(this.value.endDate),
        utils.DateUtils.ISO_DATE_ONLY_FORMAT
      );

      return `${this.property}:'${startDateFormatted}' TO '${endDateFormatted}'`;
    }
    return `${this.property}:*`;
  }
}

export default DateOnlyRangeFilter;
